import { Injectable } from "@angular/core";
import { Store } from "@ngxs/store";
import { GeneralSignalRResponse } from "src/app/services/signal-r/general-signal-r-response";
import { SignalRService } from "src/app/services/signal-r/signal-r.service";
import { SignalRAction } from "src/app/services/signal-r/signalr-enums";
import { Channels } from "src/app/store/channels";
import * as CommentActions from './comments.action';

@Injectable({
  providedIn: 'root'
})
export class CommentStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  // 6963: no initStore; comments are loaded per form by CommentLoadBySerialNo when comments-and-attachments opens


  initListeners() {
    this.signalRService.hubConnection?.on(Channels.COMMENTS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new CommentActions.CommentCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new CommentActions.CommentUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new CommentActions.CommentDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new CommentActions.CommentRefresh());
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new CommentActions.CommentRefreshByID(data.id));
          break;
      }
    });

  }
}
